/*
 * File: DiagnosisList.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Uses the ListHandler to make a list of diagnoses
 */
import React from "react";
import { List, ListItem, ListItemText } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ListItemHandler from "./ListItemHandler";
import PropTypes from "prop-types";

const DiagnosisList = props => (
  <List>
    {props.items.map((row, idx) => {
      const removeItem = () => {
        props.removeItem(row);
      };
      const closeId = "close-icon-" + idx;
      const dxIncludedOnProcedure = props.postChargeModel.diagnosisIsIncludedOnCharge(
        row
      );
      return (
        <ListItemHandler
          diagnosis={row}
          key={idx}
          render={(description, toggle) => (
            <ListItem divider={true} onClick={toggle}>
              <ListItemText primary={row.code} secondary={description} />
              {!dxIncludedOnProcedure && (
                <CloseIcon onClick={removeItem} id={closeId} />
              )}
            </ListItem>
          )}
        />
      );
    })}
  </List>
);

DiagnosisList.propTypes = {
  items: PropTypes.array.isRequired,
  removeItem: PropTypes.func.isRequired,
  postChargeModel: PropTypes.object.isRequired
};
export default DiagnosisList;
